export default {
    primary: {
        brightBlue: '#0194D3',
        darkBlue: '#002F64',
        white: '#fff',
    },
    secondary: {
        limeGreen: '#BCCF00',
        lilac: '#9C91C5',
        teal: '#00A9B9',
        mariner: '#2C74BA',
        lightBlue: '#bfe4f4',
        activeBlue: '#b2def1',
        paleBlue: '#F0F6F9',
        darkGreen: '#006051',
        black: '#000',
        offBlue: '#31708F',
    },
    grey: {
        base: '#666',
        mid: '#979797',
        light: '#EAEAEA',
        silver: '#CCCCCC',
    },
};
